
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="bg-white py-24">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl rounded-3xl bg-indigo-600 px-6 py-16 sm:py-24 md:px-12 lg:flex lg:items-center lg:justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Prêt à transformer vos réseaux sociaux ?
              <br />
              <span className="text-indigo-200">
                Commencez votre essai gratuit aujourd'hui.
              </span>
            </h2>
            <p className="mt-4 max-w-2xl text-lg text-indigo-100">
              Obtenez 50 crédits gratuits pour découvrir toute la puissance de Scaloo.
              Pas de carte de crédit requise.
            </p>
          </div>
          <div className="mt-10 flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0 lg:mt-0 lg:shrink-0">
            <Link to="/register">
              <Button className="h-12 rounded-md bg-white px-8 text-indigo-600 transition-all hover:bg-indigo-50">
                Démarrer l'essai gratuit
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Button
              variant="outline"
              className="h-12 rounded-md border-white/20 px-8 text-white hover:bg-white/10"
            >
              Planifier une démo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
